import { render, staticRenderFns } from "./ItemListSetting.vue?vue&type=template&id=07013b26"
import script from "./ItemListSetting.vue?vue&type=script&lang=js"
export * from "./ItemListSetting.vue?vue&type=script&lang=js"
import style0 from "./ItemListSetting.vue?vue&type=style&index=0&id=07013b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VContainer,VDivider,VRow,VTextField})
